/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from 'react'
import { auth, storage } from '../config/firebase.config';
import { ref, uploadBytesResumable, getDownloadURL, listAll, deleteObject } from 'firebase/storage';
import { toast } from 'react-toastify';
import DocumentSelector from '../components/dashboard/DocumentSelector';
import FilesContainer from '../components/dashboard/FilesContainer/FilesContainer';

const Dashboard = () => {
  const [selectedFile, setSelectedFiles] = useState(null);
  const [currentProgress, setCurrentProgress] = useState(0);
  const [fileDownloadUrls, setFileDownloadUrls] = useState([]);
  const [downloadFileName, setDownloadFileName] = useState([]);
  const [isGridView, setIsGridView] = useState(false);

  const fileInputRef = useRef();
  const currentUser = auth.currentUser;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedFile?.size > 104857600) { // Filse Size Validation
      toast.error('File Size is Too Large');
    }
    else {
      const storageRef = ref(storage, `${currentUser?.displayName}-${currentUser?.uid}/` + selectedFile?.name);
      const uploadTask = uploadBytesResumable(storageRef, selectedFile, {
        contentType: selectedFile?.type,
      });

      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on('state_changed', (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setCurrentProgress(progress.toFixed(2));

        switch (snapshot.state) {
          case 'paused':
            toast.warn('Upload is paused');
            break;
          case 'running':
            toast.success('Upload is running');
            break;
          default:
            toast.error('Some Error Occurred');
        }
      }, (error) => {
        switch (error.code) {
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            toast.error('User does not have permission to access the object')
            break;
          case 'storage/canceled':
            // User canceled the upload
            toast.error('User canceled the upload')
            break;
          case 'storage/unknown':
            // Unknown error occurred, inspect error.serverResponse
            toast.error('Unknown error occurred');
            break;
          default:
            toast.error('Some Error Occurred');
        }
      });
    }
  }

  const handleClear = () => {
    setSelectedFiles(null);
    setCurrentProgress(0);
    fileInputRef.current.value = '';
  }

  const handleDelete = async (selectedFileName) => {
    try {
      // Creating Reference of File
      const fileRef = ref(storage, `${currentUser?.displayName}-${currentUser?.uid}/` + selectedFileName);
      await deleteObject(fileRef);
      toast.success('File Delete Successfully');
      fetchData();
    } catch (error) {
      toast.error(error.code);
    }
  }

  const fetchData = async () => {
    const storageRef = ref(storage, `${currentUser?.displayName}-${currentUser?.uid}/`); // Get Reference to Cloud Storage
    try {
      const listRef = await listAll(storageRef); // Return Reference to all Nested Folders
      const { items } = listRef;
      const fileNames = items.map(itemRef => itemRef.name);
      const promiseUrls = items.map(itemRef => getDownloadURL(itemRef))
      const downloadUrls = await Promise.all(promiseUrls);
      setFileDownloadUrls(downloadUrls);
      setDownloadFileName(fileNames);
    } catch (error) {
      toast.error(error.code);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className='my-5'>
      <div className="w-full flex items-center justify-between gap-2 flex-col md:flex-row">
        <DocumentSelector
          currentProgress={currentProgress}
          fileInputRef={fileInputRef}
          handleClear={handleClear}
          handleSubmit={handleSubmit}
          setSelectedFiles={setSelectedFiles}
          selectedFile={selectedFile}
        />
      </div>
      <FilesContainer
        fileDownloadUrls={fileDownloadUrls}
        isGridView={isGridView}
        setIsGridView={setIsGridView}
        handleDelete={handleDelete}
        downloadFileName={downloadFileName}
      />
    </div>
  )
}

export default Dashboard